import { Button, Col, Flex, Form, Grid } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { objectToQuerystring, pushGtag } from "../../../../plugins/utils";
import { steps as resultSteps } from "../../../Result/enumerations/steps";
import { searchMode } from "../../enumerations/searchMode";
import { step } from "../../enumerations/step";
import { FilterBarContainer, HomeCalendar, OtherFilter } from "./components";
import FullFilter from "./components/FullFilter";
import { FilterBarProps, FormParams } from "./data";
import styles from "./styleModule";

const FilterBar: React.FC<FilterBarProps> = ({}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [steps, setSteps] = useState<string>(step.OTHER);
  const [otherParams, setOtherParams] = useState<FormParams>();
  const [showHalfDaySelector, setShowHalfDaySelector] = useState(false);
  const [selectedSearchMode, setSelectedSearchMode] = useState<string>(
    searchMode.RESORT
  );
  const [studentLimit, setStudentLimit] = useState<number>(6);

  const handlePrevStep = () => {
    pushGtag({
      event: "home_search_advanced_prev_step",
    });

    setSteps(step.OTHER);
  };

  const stepsEnum: Record<string, any> = {
    [step.FULL_SEARCH]: {
      handleOk: () => {
        const params = form.getFieldsValue();
        delete params.count;
        delete params.date;
        const finalParams = {
          ...params,
          coach_account_id: null,
          coach_designated: 0,
        };
        console.debug("finalParams", finalParams);

        pushGtag({
          event: "home_search_by_date",
          ...finalParams,
        });

        const queryString = objectToQuerystring(finalParams);
        navigate(`/search/?step=${resultSteps.SEARCH}&${queryString}`);
      },
      bodyWidth: "100%",
      showHint: false,
      content: (
        <FullFilter
          form={form}
          params={otherParams}
          setParams={setOtherParams}
          setShowHalfDaySelector={setShowHalfDaySelector}
          showHalfDaySelector={showHalfDaySelector}
          studentLimit={studentLimit}
          setStudentLimit={setStudentLimit}
        />
      ),
      btn: (
        <Col span={screens.lg ? 24 : 24} style={{ textAlign: "center" }}>
          <Button
            block
            className={styles.submit}
            type="primary"
            htmlType="submit"
          >
            {t("normal.search")}
          </Button>
        </Col>
      ),
    },
    [step.OTHER]: {
      handleOk: () => {
        const newOtherParams = form.getFieldsValue();
        delete newOtherParams.count;
        console.debug("newOtherParams", newOtherParams);

        pushGtag({
          event: "home_search_advanced_next_step",
          ...newOtherParams,
        });

        setOtherParams(newOtherParams);
        setSteps(step.DATE);
      },
      bodyWidth: "100%",
      showHint: false,
      content: (
        <OtherFilter
          form={form}
          params={otherParams}
          setParams={setOtherParams}
          setShowHalfDaySelector={setShowHalfDaySelector}
          showHalfDaySelector={showHalfDaySelector}
          studentLimit={studentLimit}
          setStudentLimit={setStudentLimit}
        />
      ),
      btn: (
        <Col span={screens.lg ? 24 : 24} style={{ textAlign: "center" }}>
          <Button
            block
            className={styles.submit}
            type="primary"
            htmlType="submit"
          >
            {t("home.searchbar.button")}
          </Button>
        </Col>
      ),
    },
    [step.DATE]: {
      handleOk: () => {
        const dateParams = form.getFieldsValue();
        delete dateParams.date;
        const finalParams = {
          ...otherParams,
          ...dateParams,
          coach_account_id: null,
          coach_designated: 0,
        };
        console.debug("finalParams", finalParams);

        pushGtag({
          event: "home_search_advanced_final",
          ...finalParams,
        });

        const queryString = objectToQuerystring(finalParams);
        navigate(`/search/?step=${resultSteps.SEARCH}&${queryString}`);
      },
      bodyWidth: "100%",
      showHint: true,
      content: <HomeCalendar params={otherParams} form={form} />,
      btn: (
        <Col
          span={screens.md ? 12 : 24}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Flex gap={8} align="center" style={{ flex: 1 }}>
            <Button
              style={{ width: "60%" }}
              block
              className={styles.dateSubmit}
              type="primary"
              htmlType="submit"
            >
              {t("normal.confirm")}
            </Button>
            <Button
              style={{ width: "40%" }}
              onClick={handlePrevStep}
              className={styles.dateSubmit}
            >
              {t("normal.prestep")}
            </Button>
          </Flex>
        </Col>
      ),
    },
  };

  useEffect(() => {
    if (!selectedSearchMode) return;
    if (selectedSearchMode === searchMode.DATE) {
      setSteps(step.FULL_SEARCH);
      return;
    }
    setSteps(step.OTHER);
  }, [selectedSearchMode]);

  return (
    <FilterBarContainer
      selectedSearchMode={selectedSearchMode}
      setSelectedSearchMode={setSelectedSearchMode}
      steps={steps}
      stepsEnum={stepsEnum}
      form={form}
    />
  );
};

export default FilterBar;
